import React from 'react';
import { MemberFilter } from '~/components';
import ContactTagFilter from './ContactTagFilter';
import FiltersGroup from './FiltersGroup';

function ContactFiltersGroup({ filters, onChange }) {
  return (
    <FiltersGroup label="Contact Filters" filters={[filters.contactOwners, filters.contactTags]}>
      <MemberFilter
        name="contactOwners"
        placeholder="Contact Owner"
        value={filters.contactOwners}
        onChange={({ target: { value } }) => onChange({ contactOwners: value })}
      />
      <ContactTagFilter
        name="contactTags"
        placeholder="Contact Tags"
        value={filters.contactTags}
        onChange={({ target: { value } }) => onChange({ contactTags: value })}
      />
    </FiltersGroup>
  );
}

export default ContactFiltersGroup;
